__turbopack_context__.v({
  "link": "Iksf7G_link",
  "list": "Iksf7G_list",
  "tabNav": "Iksf7G_tabNav",
});
